module.exports = __webpack_public_path__ + "img/helmet-safety.81a79266.svg";